import { render, staticRenderFns } from "./live-order-manager.vue?vue&type=template&id=834e989a&scoped=true&"
import script from "./live-order-manager.vue?vue&type=script&lang=js&"
export * from "./live-order-manager.vue?vue&type=script&lang=js&"
import style0 from "./live-order-manager.vue?vue&type=style&index=0&id=834e989a&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834e989a",
  null
  
)

export default component.exports